<script>
import VideoPreview from '@components/video/video-preview.vue';
import { counterMixin } from '@mixins/counter-mixin';
import { modalMethods, modalComputed } from '@state/helpers';

export default {
  components: {
    VideoPreview,
  },
  props: {},
  data() {
    return {};
  },
  mixins: [counterMixin],
  computed: {
    ...modalComputed,
    videoOpts() {
      return {
        autoplay: true,
        controls: true,
        fluid: false,
        responsive: true,
        textTrackSettings: false,
        preload: 'metadata',
        sources: [
          {
            src: this.selectedVideo.src,
          },
        ],
      };
    },
    modalSubTitle() {
      return `${this.selectedVideo.numberOfReps ? this.selectedVideo.numberOfReps + ' reps' : ''} ${
        this.selectedVideo.weight ? '• ' + this.selectedVideo.weight + ' lbs' : ''
      } ${this.selectedVideo.timeOfExercise ? '• ' + this.formattedTime(this.selectedVideo.timeOfExercise) : ''} ${
        this.selectedVideo.listOfEquipment ? '• ' + this.selectedVideo.listOfEquipment : ''
      } `;
    },
  },
  mounted() {},
  methods: {
    ...modalMethods,
    async close() {
      await this.setSelectedVideo(null);
      this.$bvModal.hide('video-preview-modal');
    },
    formattedTime(time) {
      return this.$_getFormattedSeconds(time);
    },
  },
};
</script>

<template>
  <b-modal id="video-preview-modal" centered :hide-footer="true" size="lg" no-stacking>
    <template slot="modal-title">
      <p v-if="selectedVideo" class="exercise-name">{{ selectedVideo.exerciseName }}</p>
      <p v-if="selectedVideo" class="sub-title">{{ modalSubTitle }}</p>
    </template>
    <div v-if="selectedVideo">
      <VideoPreview :options="videoOpts" />
    </div>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

::v-deep .modal-content {
  border: none;
  border-radius: 8px;
  .exercise-name {
    align-items: flex-end;
    color: #000;
    display: flex;
    font-family: $base-font-family;
    font-size: 2rem;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.7px;
    line-height: 16px;
    text-transform: capitalize;
  }

  .sub-title {
    color: #000;
    font-family: $base-font-family;
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 300;
    letter-spacing: 0.7px;
    line-height: 17px;
    mix-blend-mode: normal;
    opacity: 0.5;
    text-transform: capitalize;
  }

  .modal-header {
    background-color: white;
    border-bottom: none;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 4rem 4rem;

    .close {
      color: black;
    }

    .modal-title {
      color: black;
    }
  }
  .modal-body {
    padding: 0;
    div {
      border-radius: 0 !important;
      height: 45vh;
      overflow: hidden;
      width: 100%;
    }
  }
  .vjs-tech {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    height: 45vh;
    object-fit: cover;
    width: 100% !important;
  }
}
</style>
